import React, { createContext, useEffect, useState } from "react";
import { SearchFilters } from "../entry/server/movie";
import { videoRepo } from "../repo/video-repo";
import { MenuData } from "../entry/server/app";
import { appRepo } from "../repo/app-repo";
import { User, UserVIPData } from "../entry/server/user";
import { userRepo } from "../repo/user-repo";

export type Notification = {
    type: "success" | "danger" | "warning" | "info";
    message: string;
    hidden?: boolean;
    duration?: number;
}

export type SuccessAlertData = {
    title: string;
    message: string;
}

export type AppContextType = {
    searchFilters: SearchFilters | null;
    setSearchFilters: (searchFilters: SearchFilters) => void;
    isSearchFilterOpen: boolean;
    setIsSearchFilterOpen: (isSearchFilterOpen: boolean) => void;
    menuData: MenuData | null;
    setMenuData: (menuData: MenuData) => void;

    isLoggedIn: boolean;
    setIsLoggedIn: (isLoggedIn: boolean) => void;
    user: User | null;
    setUser: (user: User | null) => void;
    vipData: UserVIPData | null;
    setVipData: (vipData: UserVIPData | null) => void;
    notification: Notification | null;
    setNotification: (notification: Notification | null) => void;

    hasUnreadNotifications: boolean;
    setHasUnreadNotifications: (hasUnreadNotifications: boolean) => void;

    successAlert: SuccessAlertData | null;
    setSuccessAlert: (successAlert: SuccessAlertData | null) => void;
}

export const WonmovContext = createContext<AppContextType>({
    searchFilters: null,
    setSearchFilters: () => {},
    isSearchFilterOpen: false,
    setIsSearchFilterOpen: () => {},
    menuData: null,
    setMenuData: () => {},
    isLoggedIn: false,
    setIsLoggedIn: () => {},
    user: null,
    setUser: () => {},
    vipData: null,
    setVipData: () => {},
    notification: null,
    setNotification: () => {},
    hasUnreadNotifications: false,
    setHasUnreadNotifications: () => {},
    successAlert: null,
    setSuccessAlert: () => {},
});

export default function WonmovProvider({ initialUser, initialVipData, initialUnreadNotificationsCount, children }: { initialUser: User | null, initialVipData: UserVIPData | null, initialUnreadNotificationsCount: number, children: React.ReactNode }) {
    const [searchFilters, setSearchFilters] = useState<SearchFilters | null>(null);
    const [isSearchFilterOpen, setIsSearchFilterOpen] = useState(false);
    const [menuData, setMenuData] = useState<MenuData | null>(null);
    const [isLoggedIn, setIsLoggedIn] = useState(initialUser !== null);
    const [user, setUser] = useState<User | null>(initialUser);
    const [vipData, setVipData] = useState<UserVIPData | null>(initialVipData);
    const [notification, setNotification] = useState<Notification | null>(null);
    const [hasUnreadNotifications, setHasUnreadNotifications] = useState(initialUnreadNotificationsCount > 0);
    const [successAlert, setSuccessAlert] = useState<SuccessAlertData | null>(null);

    useEffect(function () {
        videoRepo.getSearchFilters().then(function (res) {
            if (res.status) {
                setSearchFilters(res.data!);
            }
        }).catch(function () {});

        appRepo.getMenuData().then(function (res) {
            if (res.status) {
                setMenuData(res.data!);
            }
        }).catch(function () {});
    }, []);
    
    return (
        <WonmovContext.Provider value={{ searchFilters, setSearchFilters, isSearchFilterOpen, setIsSearchFilterOpen, menuData, setMenuData, isLoggedIn, setIsLoggedIn, user, setUser, vipData, setVipData, notification, setNotification, hasUnreadNotifications, setHasUnreadNotifications, successAlert, setSuccessAlert }}>
            {children}
        </WonmovContext.Provider>
    )
}
